import { defineMessages } from 'react-intl';

export default defineMessages({
    forgotYourPassword: {
        id: 'auth.components.ForgotUsername.Forgot Username?',
        defaultMessage: 'Forgot Username?'
    },
    forgotYourPasswordDescriptionExt: {
        id: 'ri.auth.components.ForgotUsername.Please provide the following information for us to send you your username. On submit you will receive an email with your username.',
        defaultMessage: 'Please provide the following information for us to send you your username. On submit you will receive an email with your username.'
    },
    fieldIncorrect: {
        id: 'auth.components.ForgotUsername.Enter your policy number and email address below.',
        defaultMessage: 'Enter your policy number and email address below.'
    },
    invalidAttempt: {
        id: 'auth.components.ForgotUsername.Invalid Attempt',
        defaultMessage: 'Invalid Attempt'
    },
    userNameExt: {
        id: 'ri.auth.components.ForgotUsername.Policy Number:',
        defaultMessage: 'Policy Number:'
    },
    email: {
        id: 'auth.components.ForgotUsername.Email:',
        defaultMessage: 'Email:'
    },
    backToSignIn: {
        id: 'auth.components.ForgotUsername.Back to Sign In',
        defaultMessage: 'Back to Sign In'
    },
    send: {
        id: 'auth.components.ForgotUsername.Send',
        defaultMessage: 'Send'
    },
    checkYourEmail: {
        id: 'auth.components.ForgotUsername.Check your email',
        defaultMessage: 'Check your email'
    },
    linkHasBeenSent: {
        id: 'auth.components.ForgotUsername.An email with your username has been sent to the email address provided. Please return to the login page to log in.',
        defaultMessage: 'An email with your username has been sent to the email address provided. Please return to the login page to log in.'
    },
    invalidEmailAttempt: {
        id: 'auth.components.ForgotUsername.Invalid attempt',
        defaultMessage: 'Invalid attempt'
    },
    noEmailMatch: {
        id: 'auth.components.ForgotUsername.We could not match an account with the email address you entered, please try again.',
        defaultMessage: 'We could not match an account with the email address you entered, Please try again or contact mailto:policyholdersupport@ri-net.com Portal Support for further assistance.'
    },
    unableToProcessRequest: {
        id: 'auth.components.ForgotUsername.Unable to process your request',
        defaultMessage: 'Unable to process your request'
    }
});
